import {SelectCreatable} from '@wandb/weave/components/Form/Select';
import React from 'react';

import {spanMetricOptions} from '../constants';
import {type MetricPathOption} from '../types';

type SpanMetricSelectorProps = {
  selectedPath: string;
  onPathChange: (value: string) => void;
  hasError: boolean;
};

/**
 * Metric picker for spans-source alerts: curated numeric span metrics plus
 * free-form `custom_attrs_{float,int}.<key>` entries.
 */
export const SpanMetricSelector = ({
  selectedPath,
  onPathChange,
  hasError,
}: SpanMetricSelectorProps) => {
  const selectedOption: MetricPathOption | null = selectedPath
    ? (spanMetricOptions.find(o => o.value === selectedPath) ?? {
        value: selectedPath,
        label: selectedPath,
      })
    : null;

  return (
    <SelectCreatable<MetricPathOption, false>
      value={selectedOption}
      options={spanMetricOptions}
      onChange={newValue => onPathChange(newValue?.value || '')}
      isClearable={true}
      placeholder="Select or enter a span metric..."
      menuPortalTarget={document.body}
      errorState={hasError}
      formatCreateLabel={(inputValue: string) => `Use "${inputValue}"`}
    />
  );
};
